export default "__VITE_ASSET__BTLMmzMs__"